import { __rest } from './../../external/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';

const mediaQueries = (breakpoints, style) => ({
    xsmall: css `
    @media (min-width: 0px) {
      ${style}
    }
  `,
    small: css `
    @media (min-width: ${breakpoints.small}) {
      ${style}
    }
  `,
    medium: css `
    @media (min-width: ${breakpoints.medium}) {
      ${style}
    }
  `,
    large: css `
    @media (min-width: ${breakpoints.large}) {
      ${style}
    }
  `,
    xlarge: css `
    @media (min-width: ${breakpoints['1xlarge']}) {
      ${style}
    }
  `,
});
const GridContainer = styled.div(({ theme: { olist: { breakpoints, components }, }, }) => css `
    max-width: ${components.grid.container['max-width']};
    box-sizing: content-box;

    margin-left: ${components.grid.container.margin.xsmall};
    margin-right: ${components.grid.container.margin.xsmall};

    ${mediaQueries(breakpoints, css `
        margin-left: ${components.grid.container.margin.small};
        margin-right: ${components.grid.container.margin.small};
      `).small}

    ${mediaQueries(breakpoints, css `
        margin-left: ${components.grid.container.margin.medium};
        margin-right: ${components.grid.container.margin.medium};
      `).medium}

    ${mediaQueries(breakpoints, css `
        margin-left: ${components.grid.container.margin.large};
        margin-right: ${components.grid.container.margin.large};
      `).large}

    ${mediaQueries(breakpoints, css `
        margin-left: ${components.grid.container.margin.xlarge};
        margin-right: ${components.grid.container.margin.xlarge};
      `).xlarge}
  `);
const Grid = styled.div(({ theme: { olist: { breakpoints, components }, }, }) => css `
    width: 100%;

    display: grid;
    grid-gap: ${components.grid.gutter.small};
    grid-template-columns: repeat(4, minmax(0, 1fr));

    ${mediaQueries(breakpoints, css `
        grid-template-columns: repeat(8, minmax(0, 1fr));
        grid-gap: ${components.grid.gutter.medium};
      `).small}

    ${mediaQueries(breakpoints, css `
        grid-template-columns: repeat(12, minmax(0, 1fr));
      `).medium}
  `);
const removeNumberFromBreakpoint = (breakpoint) => breakpoint.replace(/\d/g, '');
const getColumnStyle = (breakpoints, props) => {
    const breakpointKeys = Object.keys(breakpoints);
    const columnStyle = breakpointKeys
        .filter((breakpoint) => {
        const breakpointWithoutNumber = removeNumberFromBreakpoint(breakpoint);
        return (props[breakpointWithoutNumber] === 0 ||
            (breakpointWithoutNumber && props[breakpointWithoutNumber]));
    })
        .map((breakpoint) => {
        const currentBreakpoint = removeNumberFromBreakpoint(breakpoint);
        const columnSize = props[currentBreakpoint];
        const offsetValue = props[`${currentBreakpoint}-offset`];
        if (columnSize === 0) {
            return mediaQueries(breakpoints, css `
            display: none;
          `)[currentBreakpoint];
        }
        return mediaQueries(breakpoints, css `
          display: flex;
          grid-column: ${offsetValue ? Number(offsetValue) + 1 : 'auto'} / span
            ${columnSize};
        `)[currentBreakpoint];
    });
    return columnStyle;
};
const GridItem = styled.div((_a) => {
    var { alignItems = 'flex-start', justifyContent = 'flex-start', theme: { olist: { breakpoints }, } } = _a, props = __rest(_a, ["alignItems", "justifyContent", "theme"]);
    return css `
    display: flex;
    align-items: ${alignItems};
    justify-content: ${justifyContent};

    grid-column-end: span ${props.xsmall || 4};
    grid-column-start: ${props['xsmall-offset'] || 1};
    width: 100%;

    ${getColumnStyle(breakpoints, props)}
  `;
});

export { Grid, GridContainer, GridItem };
